module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-appsettings"
  }, [_c('a', {
    staticClass: "u-button u-button-secondary kiwi-appsettings-close",
    on: {
      "click": _vm.closeSettings
    }
  }, [_vm._v(_vm._s(_vm.$t('close')))]), _vm._v(" "), _c('form', {
    staticClass: "u-form"
  }, [_c('tabbed-view', [_c('tabbed-tab', {
    attrs: {
      "header": _vm.$t('settings_general'),
      "focus": true
    }
  }, [_c('div', {
    staticClass: "kiwi-appsettings-section kiwi-appsettings-general"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('settings_general')))]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_theme')) + ": ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.theme),
      expression: "theme"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.theme = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.settings.themes), function(t) {
    return _c('option', {
      domProps: {
        "value": t.name
      }
    }, [_vm._v(_vm._s(t.name))])
  })), _vm._v(" "), _c('a', {
    staticClass: "kiwi-appsettings-theme-reload",
    attrs: {
      "title": "Refresh Theme"
    },
    on: {
      "click": _vm.refreshTheme
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), (_vm.theme === 'custom') ? _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_themeurl')) + ": ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customThemeUrl),
      expression: "customThemeUrl"
    }],
    staticClass: "u-input",
    domProps: {
      "value": (_vm.customThemeUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customThemeUrl = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_show_autocomplete')) + ": ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingShowAutoComplete),
      expression: "settingShowAutoComplete"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingShowAutoComplete) ? _vm._i(_vm.settingShowAutoComplete, null) > -1 : (_vm.settingShowAutoComplete)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.settingShowAutoComplete,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingShowAutoComplete = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.settingShowAutoComplete = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settingShowAutoComplete = $$c
        }
      }
    }
  })]), _vm._v(" "), (_vm.themeSupportsMonospace) ? _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_use_monospace')) + ": ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingUseMonospace),
      expression: "settingUseMonospace"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingUseMonospace) ? _vm._i(_vm.settingUseMonospace, null) > -1 : (_vm.settingUseMonospace)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.settingUseMonospace,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingUseMonospace = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.settingUseMonospace = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settingUseMonospace = $$c
        }
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "kiwi-appsettings-section kiwi-appsettings-messages"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('settings_messages_title')))]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_layout_compact')) + ": ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingMessageLayout),
      expression: "settingMessageLayout"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingMessageLayout) ? _vm._i(_vm.settingMessageLayout, null) > -1 : (_vm.settingMessageLayout)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.settingMessageLayout,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingMessageLayout = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.settingMessageLayout = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settingMessageLayout = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_timestamps')) + ": ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingBufferShowTimestamps),
      expression: "settingBufferShowTimestamps"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingBufferShowTimestamps) ? _vm._i(_vm.settingBufferShowTimestamps, null) > -1 : (_vm.settingBufferShowTimestamps)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.settingBufferShowTimestamps,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingBufferShowTimestamps = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.settingBufferShowTimestamps = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settingBufferShowTimestamps = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_24hour_timestamps')) + ": ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timestamps_24h),
      expression: "timestamps_24h"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.timestamps_24h) ? _vm._i(_vm.timestamps_24h, null) > -1 : (_vm.timestamps_24h)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.timestamps_24h,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.timestamps_24h = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.timestamps_24h = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.timestamps_24h = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_emoticons')) + ": ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingBufferShowEmoticons),
      expression: "settingBufferShowEmoticons"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingBufferShowEmoticons) ? _vm._i(_vm.settingBufferShowEmoticons, null) > -1 : (_vm.settingBufferShowEmoticons)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.settingBufferShowEmoticons,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingBufferShowEmoticons = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.settingBufferShowEmoticons = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settingBufferShowEmoticons = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_block_private')) + ": ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingBufferBlockPms),
      expression: "settingBufferBlockPms"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingBufferBlockPms) ? _vm._i(_vm.settingBufferBlockPms, null) > -1 : (_vm.settingBufferBlockPms)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.settingBufferBlockPms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingBufferBlockPms = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.settingBufferBlockPms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settingBufferBlockPms = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_scrollback')) + ": ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingBufferScrollbackSize),
      expression: "settingBufferScrollbackSize"
    }],
    staticClass: "u-input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.settingBufferScrollbackSize)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.settingBufferScrollbackSize = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_formatting')) + ": ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingBufferExtraFormatting),
      expression: "settingBufferExtraFormatting"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingBufferExtraFormatting) ? _vm._i(_vm.settingBufferExtraFormatting, null) > -1 : (_vm.settingBufferExtraFormatting)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.settingBufferExtraFormatting,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingBufferExtraFormatting = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.settingBufferExtraFormatting = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settingBufferExtraFormatting = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_nick_colouring')) + ": ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingBufferColourNicknames),
      expression: "settingBufferColourNicknames"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingBufferColourNicknames) ? _vm._i(_vm.settingBufferColourNicknames, null) > -1 : (_vm.settingBufferColourNicknames)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.settingBufferColourNicknames,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingBufferColourNicknames = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.settingBufferColourNicknames = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settingBufferColourNicknames = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "kiwi-appsettings-section kiwi-appsettings-notifications"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('notifications')))]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_show_joinpart')) + ": ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingBufferTrafficAsActivity),
      expression: "settingBufferTrafficAsActivity"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingBufferTrafficAsActivity) ? _vm._i(_vm.settingBufferTrafficAsActivity, null) > -1 : (_vm.settingBufferTrafficAsActivity)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.settingBufferTrafficAsActivity,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingBufferTrafficAsActivity = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.settingBufferTrafficAsActivity = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settingBufferTrafficAsActivity = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_mute_sound')) + ": ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingBufferMuteSound),
      expression: "settingBufferMuteSound"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingBufferMuteSound) ? _vm._i(_vm.settingBufferMuteSound, null) > -1 : (_vm.settingBufferMuteSound)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.settingBufferMuteSound,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingBufferMuteSound = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.settingBufferMuteSound = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settingBufferMuteSound = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_highlight')) + ": ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingHighlights),
      expression: "settingHighlights"
    }],
    staticClass: "u-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.settingHighlights)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.settingHighlights = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "kiwi-appsettings-section kiwi-appsettings-operator-tools"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('operator_tools')))]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_default_ban_mask')) + ": ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingDefaultBanMask),
      expression: "settingDefaultBanMask"
    }],
    staticClass: "u-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.settingDefaultBanMask)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.settingDefaultBanMask = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_default_kick_reason')) + ": ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingDefaultKickReason),
      expression: "settingDefaultKickReason"
    }],
    staticClass: "u-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.settingDefaultKickReason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.settingDefaultKickReason = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('tabbed-tab', {
    attrs: {
      "header": _vm.$t('settings_aliases')
    }
  }, [_c('div', {
    staticClass: "kiwi-appsettings-section kiwi-appsettings-aliases"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('settings_aliases')))]), _vm._v(" "), _c('settings-aliases')], 1)])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-df6a9f2e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppSettings.vue
// module id = 509
// module chunks = 2